import { useQuery } from '@tanstack/react-query';

import { taskAssignsApi } from '../axios';
import { groupsApi } from '../axios/groups';

export function useUsersQuery() {
  return useQuery({
    queryKey: ['allUsers'],
    queryFn: async () => {
      const { mobile_users } = await taskAssignsApi.getLightFilterMetadata();
      return mobile_users?.map((user) => ({
        id: user[1],
        name: user[0],
      }));
    },
  });
}

export function useUserGroupsQuery() {
  return useQuery({
    queryKey: ['userGroups'],
    queryFn: async () => {
      const { groups } = await groupsApi.getGroups();
      return groups;
    },
  });
}
